import script from "./change-photo.vue?vue&type=script&lang=ts&setup=true"
export * from "./change-photo.vue?vue&type=script&lang=ts&setup=true"

import "./change-photo.vue?vue&type=style&index=0&id=1df569df&lang=scss&scoped=true"
import "./change-photo.vue?vue&type=style&index=1&id=1df569df&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df569df"]])

export default __exports__